import script from "./TradePassportAbout.vue?vue&type=script&setup=true&lang=js"
export * from "./TradePassportAbout.vue?vue&type=script&setup=true&lang=js"

import "./TradePassportAbout.vue?vue&type=style&index=0&id=07d0f017&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d0f017"]])

export default __exports__